import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Send } from 'lucide-react';
import { useState } from 'react';
import { Modal, useToast } from '../../componentes/ui';
import { api } from '../../lib/api';
import { chaves } from '../../lib/consultas';

interface ModeloDisponivel {
  nome: string;
  idioma: string;
  categoria: string;
  previa: string;
}

export function ModalModelo({ conversaId, fechar }: { conversaId: string; fechar: () => void }) {
  const qc = useQueryClient();
  const toast = useToast();
  const [enviando, setEnviando] = useState<string | null>(null);
  const modelos = useQuery({
    queryKey: ['modelos', conversaId],
    queryFn: () => api<ModeloDisponivel[]>(`/api/conversas/${conversaId}/modelos`),
  });

  async function enviar(nome: string) {
    setEnviando(nome);
    try {
      await api(`/api/conversas/${conversaId}/modelos`, { metodo: 'POST', corpo: { nome } });
      qc.invalidateQueries({ queryKey: chaves.conversa(conversaId) });
      toast('Modelo enviado. Quando o cliente responder, a conversa volta ao normal');
      fechar();
    } catch (e) {
      toast((e as Error).message, 'erro');
    } finally {
      setEnviando(null);
    }
  }

  return (
    <Modal titulo="Enviar modelo de mensagem" aoFechar={fechar}>
      <p className="nota-sec" style={{ marginTop: 0 }}>
        Fora das 24h, o WhatsApp só aceita mensagens aprovadas pela Meta. Cada envio tem um custo
        pequeno.
      </p>
      {modelos.isLoading ? (
        <p className="nota-sec">Carregando…</p>
      ) : modelos.error ? (
        <p className="erro-form">{(modelos.error as Error).message}</p>
      ) : !modelos.data?.length ? (
        <p className="nota-sec">
          Nenhum modelo aprovado ainda. A Meta costuma levar de minutos a algumas horas pra
          analisar.
        </p>
      ) : (
        <div className="modelos-lista">
          {modelos.data.map((m) => (
            <div key={m.nome} className="modelo-opcao">
              <p className="modelo-previa">{m.previa}</p>
              {m.categoria === 'MARKETING' && (
                <p className="modelo-aviso">
                  Modelo de marketing: custa mais por envio. Se der, chame o cliente pelo celular (é
                  grátis).
                </p>
              )}
              <button
                className="btn primario"
                disabled={!!enviando}
                onClick={() => void enviar(m.nome)}
              >
                <Send /> {enviando === m.nome ? 'Enviando…' : 'Enviar'}
              </button>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}
